import { ref, watch } from '@vue/composition-api';

/**
 * Returns a state that's linked to localStorage
 * @param {string} key Identifier for LocalStorage
 * @param {any} defaultValue Used if there's no data in localStorage
 * @returns {import('@vue/composition-api/dist/index').Ref} A ref mutable object
 */
export default (key, defaultValue) => {
  const stateStored = window.localStorage.getItem(key) || JSON.stringify(defaultValue);
  const state = ref(JSON.parse(stateStored));
  watch(
    () => state.value,
    (stateNewVal) => {
      window.localStorage.setItem(key, JSON.stringify(stateNewVal));
    }
  );

  return state;
};
